import { Component } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';
import { ApplicationSessionService } from '../../../shared/services/application-session.service';

@Component({
  selector: 'app-logout',
  imports: [],
  template: '',
})
export class Logout {
  constructor(private auth: AuthService, session: ApplicationSessionService) {
    session.stop();
    this.auth.logout();
  }
}
